import {
  Button,
  ListContainer,
  ListContext,
  NoData,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@compass/core";
import { Permission, PermissionAction, StudentAbsence } from "generated/openApi";
import { useRouter } from "hooks";
import "moment-timezone";
import { studentAbsencePageRoute } from "pages/students/student-absences/StudentAbsencePage/StudentAbsencePage";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";

export const Absences = (props: {
  studentId: number;
  year: number | undefined;
  absences: StudentAbsence[];
  onGetList: () => void;
}) => {
  const ROOT_PERMISSION: Permission = Permission.StudentAbsence;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  return (
    <>
      <ListContainer
        header={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">Absences</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
              {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
                <Button
                  variant="text"
                  onClick={() => {
                    navigate({
                      pathname: studentAbsencePageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }),
                      search: studentAbsencePageRoute.getOptionalParams?.({
                        studentId: props.studentId,
                        schoolYear: props.year,
                      }),
                    });
                  }}
                  sx={{ minWidth: "auto" }}
                >
                  + New
                </Button>
              )}
            </Stack>
          </Stack>
        }
        tableContainer={
          <TableContainer>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="right">EXC</TableCell>
                  <TableCell align="right">UNX</TableCell>
                  <TableCell align="right">ATT</TableCell>
                  <TableCell align="right">ENR</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.absences.map((absence) => (
                  <TableRow
                    key={absence.id}
                    onClick={() =>
                      navigate({
                        pathname: studentAbsencePageRoute.getPath({
                          id: absence.id,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>
                      <Stack>
                        <Typography>
                          {absence.termType?.name} {absence.termNumber}
                        </Typography>
                        <Typography variant="caption">{absence.school?.name}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell align="right">{absence.excusedAbsences}</TableCell>
                    <TableCell align="right">{absence.unexcusedAbsences}</TableCell>
                    <TableCell align="right">{absence.daysAttended}</TableCell>
                    <TableCell align="right">{absence.daysEnrolled}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      {matchTemplatePath(studentAbsencePageRoute.templatePath) && (
        <ListContext.Provider value={{ loadList: () => props.onGetList() }}>
          <Outlet />
        </ListContext.Provider>
      )}
    </>
  );
};
